import api from "./apiClient";
import API_ENDPOINTS from "../config/apiEndpoints";
import { extractSuccessStory, firstSuccessStoryRow, isProcSuccess } from "./dmsMasterService";

function basePayload(userData, overrides = {}) {
  return {
    OrganizationId: userData?.OrganizationId || "",
    CreatedBy: userData?.StaffId || "",
    ActionType: "",
    ...overrides,
  };
}

function resolveApiError(response, row, fallback) {
  const rowMsg = row?.MSG || row?.Msg || row?.message || row?.Message;
  if (rowMsg) return String(rowMsg).trim();
  return response?.message || fallback;
}

export async function fetchEisfDocumentTypes(userData) {
  const response = await api.post(
    API_ENDPOINTS.ISF.DOCUMENT_TYPE_ACTIVITY,
    basePayload(userData, { ActionType: "GetAllDocumentType" }),
  );
  return extractSuccessStory(response);
}

export async function saveEisfDocumentType(userData, payload) {
  const response = await api.post(
    API_ENDPOINTS.ISF.DOCUMENT_TYPE_ACTIVITY,
    basePayload(userData, payload),
  );
  const row = firstSuccessStoryRow(response);
  if (!isProcSuccess(row) && Number(response?.success) !== 1) {
    throw new Error(
      resolveApiError(response, row, "Could not save eISF document type."),
    );
  }
  return { row, message: row?.MSG || row?.Msg || "Saved successfully." };
}

export async function deleteEisfDocumentType(userData, documentTypeId) {
  const response = await api.post(
    API_ENDPOINTS.ISF.DOCUMENT_TYPE_ACTIVITY,
    basePayload(userData, {
      ActionType: "DeleteDocumentType",
      DocumentTypeId: documentTypeId,
    }),
  );
  const row = firstSuccessStoryRow(response);
  if (!isProcSuccess(row)) {
    throw new Error(
      resolveApiError(response, row, "Failed to delete eISF document type."),
    );
  }
  return { row, message: row?.MSG || row?.Msg || "Deleted successfully." };
}

export async function fetchEisfDocumentCategories(userData) {
  const response = await api.post(
    API_ENDPOINTS.ISF.DOCUMENT_CATEGORY_ACTIVITY,
    basePayload(userData, { ActionType: "GetAllDocumentCategory" }),
  );
  return extractSuccessStory(response);
}

export async function saveEisfDocumentCategory(userData, payload) {
  const response = await api.post(
    API_ENDPOINTS.ISF.DOCUMENT_CATEGORY_ACTIVITY,
    basePayload(userData, payload),
  );
  const row = firstSuccessStoryRow(response);
  if (!isProcSuccess(row) && Number(response?.success) !== 1) {
    throw new Error(
      resolveApiError(response, row, "Could not save eISF document category."),
    );
  }
  return { row, message: row?.MSG || row?.Msg || "Saved successfully." };
}

export async function deleteEisfDocumentCategory(userData, documentCategoryId) {
  const response = await api.post(
    API_ENDPOINTS.ISF.DOCUMENT_CATEGORY_ACTIVITY,
    basePayload(userData, {
      ActionType: "DeleteDocumentCategory",
      DocumentCategoryId: documentCategoryId,
    }),
  );
  const row = firstSuccessStoryRow(response);
  if (!isProcSuccess(row)) {
    throw new Error(
      resolveApiError(response, row, "Failed to delete eISF document category."),
    );
  }
  return { row, message: row?.MSG || row?.Msg || "Deleted successfully." };
}
